import exodus from './exodus.png'
import metamask from './metamask.png'
import safepal from './safepal.png'
import trust from './Trust.png'
import binance from './binance.png'
import bitget from './bitget.png'
import coinbase from './coinbase.png'
import cryptocom from './cryptocom.png'
import uniswap from './uniswap.png'
import cashapp from './cashapp.png'
import shakepay from './shakepay.png'
import btc from './btc.jpg'
import eth from './eth.jpg'
import usdc from './usdc.jpg'
import usdt from './usdt.jpg'

const depoIMG = {
    exodus: exodus,
    metamask: metamask,
    safepal: safepal,
    trust: trust,
    binance: binance,
    bitget: bitget,
    coinbase: coinbase,
    cryptocom: cryptocom,
    uniswap: uniswap,
    cashapp: cashapp,
    shakepay: shakepay,
    btc: btc,
    eth: eth,
    usdc: usdc,
    usdt: usdt,
}

export default depoIMG;